export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8990.507270da.jpg";